import React, { useEffect } from 'react';

export const ImageViewerModal = ({ src, onClose }) => {
    useEffect(() => {
      return () => {
        if (src && src.startsWith('blob:')) {
          URL.revokeObjectURL(src);
        }
      };
    }, [src]);
    
    if (!src) return null;
  
    const handleImageError = (e) => {
      e.target.onerror = null; 
      e.target.src = `https://placehold.co/600x400/EEE/31343C?text=Lỗi+tải+ảnh`;
    };
  
    return (
      <div className="fixed inset-0 bg-black bg-opacity-75 z-[60] flex justify-center items-center p-4" onClick={onClose}>
        <img 
          src={src} 
          alt="Xem trước ảnh" 
          className="max-w-[90vw] max-h-[90vh] rounded-lg object-contain" 
          onClick={(e) => e.stopPropagation()}
          onError={handleImageError} 
        />
      </div>
    );
  };